import { render, staticRenderFns } from "./robotClick.vue?vue&type=template&id=0fb3fe74&scoped=true&"
import script from "./robotClick.vue?vue&type=script&lang=js&"
export * from "./robotClick.vue?vue&type=script&lang=js&"
import style0 from "./robotClick.vue?vue&type=style&index=0&id=0fb3fe74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3fe74",
  null
  
)

export default component.exports